<template>
    <div v-if="shouldShow">
        <el-tag :size="size" :type="postTag.type">{{ postTag.label }}</el-tag>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'TagsPosts',
  props: ['post', 'size', 'typeObjet', 'typeOffre', 'annonceParente'],
  computed: {
    ...mapGetters(['isBailleurSocial']),
    shouldShow () {
      return this.isBailleurSocial && (this.post || this.typeObjet)
    },
    postTag () {
      const typeObjet = this.post ? this.post.typeObjet : this.typeObjet
      const typeOffre = this.post ? this.post.typeOffre : this.typeOffre
      const annonceParente = this.post ? this.post.annonceParente : this.annonceParente

      if (typeObjet >= 3000 && typeObjet < 4000) {
        return { type: 'warning', label: 'Prog. neuf' }
      }
      if (typeObjet >= 4000 && typeObjet < 5000) {
        return { type: 'danger', label: 'Lot neuf' }
      }
      if (annonceParente) {
        return { type: 'danger', label: 'Lot neuf' }
      }
      if (typeOffre === 'G') {
        return { type: 'warning', label: 'Vente neuf' }
      }
      return { type: 'success', label: 'Immo ancien' }
    }
  }
}
</script>

<style>
    .el-tag.el-tag--warning {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #ffffff;
        border-radius: 15px;
    }

    .el-tag.el-tag--danger {
        background-color: #d24554;
        border-color: #d24554;
        color: #ffffff;
        border-radius: 15px;
    }

    .el-tag.el-tag--success {
        background-color: #25a78d;
        border-color: #25a78d;
        color: #ffffff;
        border-radius: 15px;
    }
</style>
